module.exports = __webpack_public_path__ + "static/media/session-complete-icon.198cd1c1.svg";